import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import BrandMark from "../Clearith/BrandMark";
import MobileMenu from "../MobileMenu/MobileMenu";

const navItems = [
  { label: "Accueil", to: "/" },
  { label: "À propos", to: "/a-propos" },
  { label: "Formations", to: "/formations" },
  { label: "Méthode", to: "/methode-pedagogique" },
  { label: "Financement", to: "/financement" },
  { label: "Accessibilité", to: "/accessibilite" },
  { label: "Contact", to: "/contact" },
];

const Header: React.FC = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [mobileActive, setMobileActive] = useState(false);
  const lastScrollY = useRef<number>(0);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      if (currentScroll < lastScrollY.current && currentScroll > 100) {
        setIsSticky(true);
        window.setTimeout(() => setIsVisible(true), 10);
      } else if (currentScroll > lastScrollY.current) {
        setIsVisible(false);
        window.setTimeout(() => setIsSticky(false), 100);
      }

      if (currentScroll <= 100) {
        setIsSticky(false);
        setIsVisible(false);
      }

      lastScrollY.current = currentScroll;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavigate = () => {
    setMobileActive(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header
      id="xb-header-area"
      className="header-area header-style--one header-transparent is-sticky cl-header"
    >
      <div
        className={
          "xb-header xb-sticky-stt " +
          (isSticky ? "xb-header-area-sticky " : "") +
          (isVisible ? "xb-header-fixed" : "xb-header-hidden")
        }
      >
        <div className="container mxw-1650">
          <div className="header__wrap ul_li_between">
            <div className="xb-header-logo">
              <BrandMark />
            </div>

            <div className="main-menu__wrap navbar navbar-expand-lg p-0">
              <nav className="main-menu collapse navbar-collapse" aria-label="Navigation principale">
                <ul>
                  {navItems.map((item) => (
                    <li
                      key={item.to}
                      className={
                        location.pathname === item.to ||
                        (item.to === "/formations" &&
                          location.pathname.startsWith("/formations/"))
                          ? "active"
                          : ""
                      }
                    >
                      <Link to={item.to} onClick={handleNavigate}>
                        <span>{item.label}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>

            <div className="header-btn">
              <Link to="/contact" className="thm-btn" onClick={handleNavigate}>
                Être rappelé
              </Link>
            </div>

            <div className="header-bar-mobile side-menu d-lg-none">
              <button
                type="button"
                className="xb-nav-mobile"
                onClick={() => setMobileActive((active) => !active)}
                aria-label="Ouvrir le menu"
                aria-expanded={mobileActive}
              >
                <i className="far fa-bars" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <div className="xb-header-wrap">
            <div className={"xb-header-menu " + (mobileActive ? "active" : "")}>
              <div className="xb-header-menu-scroll">
                <button
                  type="button"
                  className="xb-menu-close xb-hide-xl xb-close"
                  onClick={() => setMobileActive(false)}
                  aria-label="Fermer le menu"
                ></button>
                <div className="xb-logo-mobile xb-hide-xl">
                  <BrandMark compact />
                </div>
                <nav className="xb-header-nav" aria-label="Navigation mobile">
                  <MobileMenu onNavigate={handleNavigate} />
                </nav>
                <div className="cl-mobile-contact">
                  <Link
                    className="thm-btn agency-btn"
                    to="/contact"
                    onClick={handleNavigate}
                  >
                    <span className="text">Demander des informations</span>
                  </Link>
                </div>
              </div>
            </div>
            <button
              type="button"
              className={"xb-header-menu-backdrop " + (mobileActive ? "active" : "")}
              onClick={() => setMobileActive(false)}
              aria-label="Fermer le menu"
            ></button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
